import React, { useState } from "react";
import Sidebar from "../component/Sidebar";
import Topbar from "../component/Topbar";
import { FiPlus, FiTrash2 } from "react-icons/fi";

function CategoryBuilder() {
  const [categories, setCategories] = useState([
    { id: 1, name: "Electronics", subcategories: [{ id: 101, name: "Mobile Phones" }] },
    { id: 2, name: "Fashion", subcategories: [] },
  ]);

  const [newCategory, setNewCategory] = useState("");
  const [newSubcategory, setNewSubcategory] = useState({});

  const addCategory = () => {
    if (!newCategory.trim()) return;
    setCategories([...categories, { id: Date.now(), name: newCategory.trim(), subcategories: [] }]);
    setNewCategory("");
  };

  const deleteCategory = (id) => {
    setCategories(categories.filter((c) => c.id !== id));
  };

  const addSubcategory = (catId) => {
    const subName = newSubcategory[catId];
    if (!subName || !subName.trim()) return;
    setCategories(
      categories.map((c) =>
        c.id === catId
          ? { ...c, subcategories: [...c.subcategories, { id: Date.now(), name: subName.trim() }] }
          : c
      )
    );
    setNewSubcategory({ ...newSubcategory, [catId]: "" });
  };

  const deleteSubcategory = (catId, subId) => {
    setCategories(
      categories.map((c) =>
        c.id === catId
          ? { ...c, subcategories: c.subcategories.filter((s) => s.id !== subId) }
          : c
      )
    );
  };

  return (
    <>
      <Topbar />
      <Sidebar />
      <main className="main-wrapper">
        <div className="main-content p-4"> 


             <h4 className="breadcrumb-title">SKU Management</h4>


<div className="row">
    <div className="col-md-8 border card p-4">

        <div className="row mb-4">
            <div className="col-md-8">
              <input
                type="text"
                className="form-control"
                placeholder="New category name"
                value={newCategory}
                onChange={(e) => setNewCategory(e.target.value)}
              />
            </div>
            <div className="col-md-4">
              <button className="btn btn-primary w-100" onClick={addCategory}>
                <FiPlus /> Add Category
              </button>
            </div>
          </div>

          {/* Category Hierarchy */}
          <div className="category-builder">
            {categories.map((c) => (
              <div key={c.id} className="row mb-3 category-card p-3 rounded shadow-sm">
                {/* Category */}
                <div className="col-12 d-flex justify-content-between align-items-center category-row">
                  <h5 className="mb-0">{c.name}</h5>
                  <button className="btn btn-sm btn-danger" onClick={() => deleteCategory(c.id)}>
                    <FiTrash2 />
                  </button>
                </div>

                {/* Subcategories */}
                <div className="col-12 subcategory-container mt-2">
                  {c.subcategories.length > 0 ? (
                    c.subcategories.map((s) => (
                      <div key={s.id} className="row subcategory-row align-items-center">
                        <div className="col-10 subcategory-name">{s.name}</div>
                        <div className="col-2 text-end">
                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => deleteSubcategory(c.id, s.id)}
                          >
                            <FiTrash2 />
                          </button>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p className="text-muted ms-3">No subcategories</p>
                  )}

                  {/* Add Subcategory */}
                  <div className="row mt-2">
                    <div className="col-8">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="New subcategory"
                        value={newSubcategory[c.id] || ""}
                        onChange={(e) =>
                          setNewSubcategory({ ...newSubcategory, [c.id]: e.target.value })
                        }
                      />
                    </div>
                    <div className="col-4">
                      <button
                        className="btn btn-primary w-100"
                        onClick={() => addSubcategory(c.id)}
                      >
                        <FiPlus /> Add Subcategory
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>


    </div>

    <div className="col-md-4"></div>
</div>
          {/* Add New Category */}
          
        </div>
      </main>

      <style>
        {`
          .category-card {
            border-left: 4px solid #0d6efd;
            background: #fff;
            transition: box-shadow 0.2s;
          }
          .category-card:hover {
            box-shadow: 0 8px 20px rgba(0,0,0,0.08);
          }
          .subcategory-container {
            position: relative;
            margin-left: 20px;
            padding-left: 15px;
            border-left: 2px solid #dee2e6;
          }
          .subcategory-row {
            padding: 4px 0;
            position: relative;
          }
          .subcategory-row::before {
            content: '';
            position: absolute;
            top: 50%;
            left: -10px;
            width: 10px;
            height: 2px;
            background-color: #dee2e6;
          }
        `}
      </style>
    </>
  );
}

export default CategoryBuilder;
